exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".weforsys-opts[data-v-149fdbe0]{display:inline-block}", ""]);

// exports
